module.exports = __webpack_public_path__ + "img/pt-howWork.809d6d37.png";